import { LoadingCirculo } from "components/LoadingCirculo";
import { Container } from "./style";
import { useEffect, useState } from "react";
import { IEstatisticasLotePagamento } from "../../../../../interface/IEstatisticasLotePagamento";
import { formatarDinheiro } from "_utils/Money";

interface IProps {
  item:
    | "qtdProcessos"
    | "totalPagarFornecedor"
    | "custoProcesso"
    | "servicoReceber";
  id: number;
  estatisticasLotesPagamento: IEstatisticasLotePagamento[];
}

export function LoadingEstatisticaLote({
  item,
  id,
  estatisticasLotesPagamento,
}: IProps) {
  const [valorMostrar, setValorMostrar] = useState<any>(null);

  useEffect(() => {
    const processoValor = estatisticasLotesPagamento.find(
      (item) => item.idLote == id
    )?.[item];

    if (processoValor) {
      setValorMostrar(
        item == "qtdProcessos"
          ? processoValor
          : formatarDinheiro(Number(processoValor))
      );
      return;
    }

    setValorMostrar(estatisticasLotesPagamento ? "-" : null);
  }, [estatisticasLotesPagamento]);

  return (
    <Container>
      {valorMostrar ?? <LoadingCirculo mostrar height={1.5} />}
    </Container>
  );
}
